import * as React from "react";

const SuccessIcon = ({ size = 24, color = '#198038', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 72 72"
    {...props}
  >
    <path
      fill="#161616"
      stroke={color}
      strokeWidth="5"
      d="M36 8.5a27.5 27.5 0 0 1 25.406 16.977 27.499 27.499 0 0 1-44.851 29.968A27.5 27.5 0 0 1 36 8.5Zm10.142 3.018A26.502 26.502 0 0 0 10.009 30.83a26.5 26.5 0 1 0 36.133-19.312Zm.133 16.48a.5.5 0 0 1 .353.145l.002.002a.5.5 0 0 1 0 .71l-.008.007L31.624 43.86a.5.5 0 0 1-.345.141h-.004a.5.5 0 0 1-.278-.083l-.076-.062-7.04-7.069-.07-.07-.075-.065-.071-.075a.5.5 0 0 1-.07-.487.5.5 0 0 1 .846-.143l.063.074 6.788 6.788 1.768-1.772 12.863-12.893a.5.5 0 0 1 .352-.145Z"
    ></path>
  </svg>
);

export default SuccessIcon;
